import { render } from "./studioRoomDetail.vue?vue&type=template&id=0c9fb9f7&scoped=true"
import script from "./studioRoomDetail.vue?vue&type=script&lang=js"
export * from "./studioRoomDetail.vue?vue&type=script&lang=js"

import "./studioRoomDetail.vue?vue&type=style&index=0&id=0c9fb9f7&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9fb9f7"]])

export default __exports__